import { lazy } from "react";
import type { RouteDefinition } from "./route-types";

const Icons = lazy(() => import("../../../components/icons/icons"));
const Widget = lazy(() => import("../../../components/widgets/widgets"));
const Accordioncollapse = lazy(() => import("../../../components/advanced-ui/accordions-collapse/accordions-collapse"));
const Carousel = lazy(() => import("../../../components/advanced-ui/carousel/carousel"));
const Draggable = lazy(() => import("../../../components/advanced-ui/draggable-cards/draggable-cards"));
const Modalcloses = lazy(() => import("../../../components/advanced-ui/modals-closes/modals-closes"));
const Navbar = lazy(() => import("../../../components/advanced-ui/navbar/navbar"));
const Offcanvas = lazy(() => import("../../../components/advanced-ui/offcanvas/offcanvas"));
const Placeholder = lazy(() => import("../../../components/advanced-ui/placeholders/placeholders"));
const Ratings = lazy(() => import("../../../components/advanced-ui/ratings/ratings"));
const Swiperjs = lazy(() => import("../../../components/advanced-ui/swiper-js/swiper-js"));
const Fullcalender = lazy(() => import("../../../components/apps/full-calendar/full-calendar"));
const Gallery = lazy(() => import("../../../components/apps/gallery/gallery"));
const Sweetalert = lazy(() => import("../../../components/apps/sweet-alerts/sweet-alerts"));
const Companies = lazy(() => import("../../../components/apps/crm/companies/companies"));
const Crmcontact = lazy(() => import("../../../components/apps/crm/contacts/contacts"));
const Deals = lazy(() => import("../../../components/apps/crm/deals/deals"));
const Leads = lazy(() => import("../../../components/apps/crm/leads/leads"));
const Buysell = lazy(() => import("../../../components/apps/crypto/buy-sell/buy-sell"));
const Currencyexchange = lazy(() => import("../../../components/apps/crypto/currency-exchange/currency-exchange"));
const Marketcap = lazy(() => import("../../../components/apps/crypto/market-cap/market-cap"));
const Transaction = lazy(() => import("../../../components/apps/crypto/transactions/transactions"));
const Wallet = lazy(() => import("../../../components/apps/crypto/wallet/wallet"));
const Candidatedetails = lazy(() => import("../../../components/apps/jobs/candidate-details/candidate-details"));
const Jobdetails = lazy(() => import("../../../components/apps/jobs/job-details/job-details"));
const Joblist = lazy(() => import("../../../components/apps/jobs/jobs-list/jobs-list"));
const Jobpost = lazy(() => import("../../../components/apps/jobs/job-post/job-post"));
const Searchcandidate = lazy(() => import("../../../components/apps/jobs/search-candidate/search-candidate"));
const Searchcompany = lazy(() => import("../../../components/apps/jobs/search-company/search-company"));
const Searchjob = lazy(() => import("../../../components/apps/jobs/search-jobs/search-jobs"));
const Createnft = lazy(() => import("../../../components/apps/nft/create-nft/create-nft"));
const Liveauction = lazy(() => import("../../../components/apps/nft/live-auction/live-auction"));
const Marketplace = lazy(() => import("../../../components/apps/nft/market-place/market-place"));
const Nftdetails = lazy(() => import("../../../components/apps/nft/nft-details/nft-details"));
const Walletintegration = lazy(() => import("../../../components/apps/nft//wallet-integration/wallet-integration"));
const Createproject = lazy(() => import("../../../components/apps/projects/create-project/create-project"));
const Projectlist = lazy(() => import("../../../components/apps/projects/projects-list/projects-list"));
const Projectoverview = lazy(() => import("../../../components/apps/projects/project-overview/project-overview"));
const Kanbanboard = lazy(() => import("../../../components/apps/task/kanban-board/kanban-board"));
const Listview = lazy(() => import("../../../components/apps/task/list-view/list-view"));
const Taskdetails = lazy(() => import("../../../components/apps/task/task-details/task-details"));
const Areachart = lazy(() => import("../../../components/charts/apex-charts/area-chart/area-chart"));
const Barchart = lazy(() => import("../../../components/charts/apex-charts/bar-chart/bar-chart"));
const Boxplotchart = lazy(() => import("../../../components/charts/apex-charts/boxplot-chart/boxplot-chart"));
const Bubblechart = lazy(() => import("../../../components/charts/apex-charts/bubble-chart/bubble-chart"));
const Candlestickchart = lazy(() => import("../../../components/charts/apex-charts/candlestick-chart/candlestick-chart"));
const Columnchart = lazy(() => import("../../../components/charts/apex-charts/column-chart/column-chart"));
const Heatmapchart = lazy(() => import("../../../components/charts/apex-charts/heatmap-chart/heatmap-chart"));
const Linechart = lazy(() => import("../../../components/charts/apex-charts/line-chart/line-chart"));
const Mixedchart = lazy(() => import("../../../components/charts/apex-charts/mixed-chart/mixed-chart"));
const Piechart = lazy(() => import("../../../components/charts/apex-charts/pie-chart/pie-chart"));
const Polarareachart = lazy(() => import("../../../components/charts/apex-charts/polararea-chart/polararea-chart"));
const Radarchart = lazy(() => import("../../../components/charts/apex-charts/radar-chart/radar-chart"));
const Radialbarchart = lazy(() => import("../../../components/charts/apex-charts/radialbar-chart/radialbar-chart"));
const Rangeareachart = lazy(() => import("../../../components/charts/apex-charts/range-area-chart/range-area-chart"));
const Scatterchart = lazy(() => import("../../../components/charts/apex-charts//scatter-chart/scatter-chart"));
const Timelinechart = lazy(() => import("../../../components/charts/apex-charts/timeline-chart/timeline-chart"));
const Treemapchart = lazy(() => import("../../../components/charts/apex-charts/treemap-chart/treemap-chart"));
const Chartjs = lazy(() => import("../../../components/charts/chartjs-charts/chartjs-charts"));
const Echart = lazy(() => import("../../../components/charts//echart-charts/echart-charts"));
const Analytics = lazy(() => import("../../../components/dashboard/analytics/analytics"));
const Course = lazy(() => import("../../../components/dashboard/course/course"));
const Crm = lazy(() => import("../../../components/dashboard/crm/crm"));
const Crypto = lazy(() => import("../../../components/dashboard/crypto/crypto"));
const Ecommerce = lazy(() => import("../../../components/dashboard/ecommerce/ecommerce"));
const Hrm = lazy(() => import("../../../components/dashboard/hrm/hrm"));
const Jobs = lazy(() => import("../../../components/dashboard/jobs/jobs"));
const Nft = lazy(() => import("../../../components/dashboard/nft/nft"));
const Personal = lazy(() => import("../../../components/dashboard/personal/personal"));
const Project = lazy(() => import("../../../components/dashboard/project/project"));
const Sales = lazy(() => import("../../../components/dashboard/sales/sales"));
const Stock = lazy(() => import("../../../components/dashboard/stock/stock"));
const Floatinglabels = lazy(() => import("../../../components/forms/floating-labels/floating-labels"));
const Formlayouts = lazy(() => import("../../../components/forms/form-layouts/form-layouts"));
const Select2 = lazy(() => import("../../../components/forms/select2/select2"));
const Validation = lazy(() => import("../../../components/forms/validation/validation"));
const Suneditor = lazy(() => import("../../../components/forms/sun-editor/sun-editor"));
const Checkradios = lazy(() => import("../../../components/forms/form-elements/checks-radios/checks-radios"));
const Colorpicker = lazy(() => import("../../../components/forms/form-elements/color-picker/color-picker"));
const Datetimepicker = lazy(() => import("../../../components/forms/form-elements/date-time-picker/date-time-picker"));
const Fileupload = lazy(() => import("../../../components/forms/form-elements/file-uploads/file-uploads"));
const Formselect = lazy(() => import("../../../components/forms/form-elements/form-select/form-select"));
const Input = lazy(() => import("../../../components/forms/form-elements/inputs/inputs"));
const Inputgroup = lazy(() => import("../../../components/forms/form-elements/input-group/input-group"));
const Inputmasks = lazy(() => import("../../../components/forms/form-elements/input-masks/input-masks"));
const Rangeslider = lazy(() => import("../../../components/forms/form-elements/range-slider/range-slider"));
const Leafletmaps = lazy(() => import("../../../components/maps/leaflet-maps/leaflet-maps"));
const Pigeonmaps = lazy(() => import("../../../components/maps/pigeon-maps/pigeon-maps"));
const Chat = lazy(() => import("../../../components/pages/chat/chat"));
const Contact = lazy(() => import("../../../components/pages/contact/contact"));
const Contactus = lazy(() => import("../../../components/pages/contactus/contactus"));
const Empty = lazy(() => import("../../../components/pages/empty/empty"));
const Faqs = lazy(() => import("../../../components/pages/faqs/faqs"));
const Notification = lazy(() => import("../../../components/cares/notifications/notifications-page"));
const Pricing = lazy(() => import("../../../components/pages/pricing/pricing"));
const Profile = lazy(() => import("../../../components/pages/profile/profile"));
const Review = lazy(() => import("../../../components/pages/review/review"));
const Team = lazy(() => import("../../../components/pages/team/team"));
const Termcondition = lazy(() => import("../../../components/pages/termcondition/termcondition"));
const Timeline = lazy(() => import("../../../components/pages/timeline/timeline"));
const Todolist = lazy(() => import("../../../components/pages/todolist/todolist"));
const Blog = lazy(() => import("../../../components/pages/blog/blog/blog"));
const Blogdetail = lazy(() => import("../../../components/pages/blog/blog-details/blog-details"));
const Createblog = lazy(() => import("../../../components/pages/blog/create-blog/create-blog"));
const Addproduct = lazy(() => import("../../../components/pages/ecommerce/addproduct/addproduct"));
const Cart = lazy(() => import("../../../components/pages/ecommerce/cart/cart"));
const Checkout = lazy(() => import("../../../components/pages/ecommerce/checkout/checkout"));
const Editproduct = lazy(() => import("../../../components/pages/ecommerce/editproduct/editproduct"));
const Oderdetails = lazy(() => import("../../../components/pages/ecommerce/oderdetails/oderdetails"));
const Order = lazy(() => import("../../../components/pages/ecommerce/order/order"));
const Product = lazy(() => import("../../../components/pages/ecommerce/product/product"));
const Productdetails = lazy(() => import("../../../components/pages/ecommerce/productdetails/productdetails"));
const Productlist = lazy(() => import("../../../components/pages/ecommerce/productlist/productlist"));
const Wishlist = lazy(() => import("../../../components/pages/ecommerce/wishlist/wishlist"));
const Mailapp = lazy(() => import("../../../components/pages/email/mailapp/mailapp"));
const Mailsetting = lazy(() => import("../../../components/pages/email/mailsetting/mailsetting"));
const Filemanager = lazy(() => import("../../../components/pages/filemanager/filemanager"));
const Createinvoice = lazy(() => import("../../../components/pages/invoice/createinvoice/createinvoice"));
const Invoicedetail = lazy(() => import("../../../components/pages/invoice/invoicedetail/invoicedetail"));
const Invoicelist = lazy(() => import("../../../components/pages/invoice/invoicelist/invoicelist"));
const Datatables = lazy(() => import("../../../components/tables/data-tables/data-tables"));
const Gridjstables = lazy(() => import("../../../components/tables/grid-js-tables/grid-js-tables"));
const Tables = lazy(() => import("../../../components/tables/tables/tables"));
const Alerts = lazy(() => import("../../../components/ui-elements/alerts/alerts"));
const Badges = lazy(() => import("../../../components/ui-elements/badge/badge"));
const Breadcrumbs = lazy(() => import("../../../components/ui-elements/breadcrumb/breadcrumb"));
const Buttongroups = lazy(() => import("../../../components/ui-elements/button-group/button-group"));
const Buttons = lazy(() => import("../../../components/ui-elements/buttons/buttons"));
const Cards = lazy(() => import("../../../components/ui-elements/cards/cards"));
const Dropdowns = lazy(() => import("../../../components/ui-elements/dropdowns/dropdowns"));
const Imagesfigure = lazy(() => import("../../../components/ui-elements/images-figures/images-figures"));
const Listgroups = lazy(() => import("../../../components/ui-elements/list-group/list-group"));
const Navtabs = lazy(() => import("../../../components/ui-elements/navs-tabs/navs-tabs"));
const Objectfit = lazy(() => import("../../../components/ui-elements/object-fit/object-fit"));
const Paginations = lazy(() => import("../../../components/ui-elements/pagination/pagination"));
const Popovers = lazy(() => import("../../../components/ui-elements/popovers/popovers"));
const Progressbar = lazy(() => import("../../../components/ui-elements/progress/progress"));
const Spinners = lazy(() => import("../../../components/ui-elements/spinners/spinners"));
const Toasts = lazy(() => import("../../../components/ui-elements/toasts/toasts"));
const Tooltips = lazy(() => import("../../../components/ui-elements/tooltips/tooltips"));
const Typographys = lazy(() => import("../../../components/ui-elements/typography/typography"));
const Additionalcontent = lazy(() => import("../../../components/utilities/additional-content/additional-content"));
const Avatars = lazy(() => import("../../../components/utilities/avatars/avatars"));
const Borders = lazy(() => import("../../../components/utilities/borders/borders"));
const Breakpoints = lazy(() => import("../../../components/utilities/breakpoints/breakpoints"));
const Colors = lazy(() => import("../../../components/utilities/colors/colors"));
const Columns = lazy(() => import("../../../components/utilities/columns/columns"));
const Flex = lazy(() => import("../../../components/utilities/flex/flex"));
const Gutters = lazy(() => import("../../../components/utilities/gutters/gutters"));
const Helpers = lazy(() => import("../../../components/utilities/helpers/helpers"));
const Position = lazy(() => import("../../../components/utilities/position/position"));
const FunnelChart = lazy(() => import("../../../components/charts/apex-charts/funnel-chart/funnel-chart"));


export const RouteData: RouteDefinition[] = [
    { id: 1, path: `/dashboards/sales`, element: <Sales /> },
    { id: 2, path: `/dashboards/analytics`, element: <Analytics /> },
    { id: 3, path: `/dashboards/ecommerce`, element: <Ecommerce /> },
    { id: 4, path: `/dashboards/crm`, element: <Crm /> },
    { id: 5, path: `/dashboards/hrm`, element: <Hrm /> },
    { id: 6, path: `/dashboards/nft`, element: <Nft /> },
    { id: 7, path: `/dashboards/crypto`, element: <Crypto /> },
    { id: 8, path: `/dashboards/jobs`, element: <Jobs /> },
    { id: 9, path: `/dashboards/project`, element: <Project /> },
    { id: 10, path: `/dashboards/course`, element: <Course /> },
    { id: 11, path: `/dashboards/stock`, element: <Stock /> },
    { id: 12, path: `/dashboards/personal`, element: <Personal /> },

    { id: 14, path: `/pages/blog/blog`, element: <Blog /> },
    { id: 15, path: `/pages/blog/blogdetail`, element: <Blogdetail /> },
    { id: 16, path: `/pages/blog/createblog`, element: <Createblog /> },
    { id: 17, path: `/pages/chat`, element: <Chat /> },
    { id: 18, path: `/pages/contact`, element: <Contact /> },
    { id: 19, path: `/pages/contactus`, element: <Contactus /> },
    { id: 20, path: `/pages/ecommerce/addproduct`, element: <Addproduct /> },
    { id: 21, path: `/pages/ecommerce/cart`, element: <Cart /> },
    { id: 22, path: `/pages/ecommerce/checkout`, element: <Checkout /> },
    { id: 23, path: `/pages/ecommerce/editproduct`, element: <Editproduct /> },
    { id: 24, path: `/pages/ecommerce/oderdetails`, element: <Oderdetails /> },
    { id: 25, path: `/pages/ecommerce/order`, element: <Order /> },
    { id: 26, path: `/pages/ecommerce/product`, element: <Product /> },
    { id: 27, path: `/pages/ecommerce/productdetails`, element: <Productdetails /> },
    { id: 28, path: `/pages/ecommerce/productlist`, element: <Productlist /> },
    { id: 29, path: `/pages/ecommerce/wishlist`, element: <Wishlist /> },
    { id: 30, path: `/pages/email/mailapp`, element: <Mailapp /> },
    { id: 31, path: `/pages/email/mailsetting`, element: <Mailsetting /> },
    { id: 32, path: `/pages/empty`, element: <Empty /> },
    { id: 33, path: `/pages/faq's`, element: <Faqs /> },
    { id: 34, path: `/pages/filemanager/filemanager`, element: <Filemanager /> },
    { id: 35, path: `/pages/invoice/createinvoice`, element: <Createinvoice /> },
    { id: 36, path: `/pages/invoice/invoicedetail`, element: <Invoicedetail /> },
    { id: 37, path: `/pages/invoice/invoicelist`, element: <Invoicelist /> },

    { id: 40, path: `/pages/notification`, element: <Notification /> },
    { id: 41, path: `/pages/pricing`, element: <Pricing /> },
    { id: 42, path: `/pages/profile`, element: <Profile /> },
    { id: 43, path: `/pages/review`, element: <Review /> },
    { id: 44, path: `/pages/team`, element: <Team /> },
    { id: 45, path: `/pages/termcondition`, element: <Termcondition /> },
    { id: 46, path: `/pages/timeline`, element: <Timeline /> },
    { id: 47, path: `/pages/todolist`, element: <Todolist /> },




    { id: 65, path: `/app/fullcalender`, element: <Fullcalender /> },
    { id: 66, path: `/app/gallery`, element: <Gallery /> },
    { id: 67, path: `/app/sweetalert`, element: <Sweetalert /> },

    { id: 68, path: `/app/projects/projectlist`, element: <Projectlist /> },
    { id: 69, path: `/app/projects/projectoverview`, element: <Projectoverview /> },
    { id: 70, path: `/app/projects/createproject`, element: <Createproject /> },

    { id: 71, path: `/app/task/kanbanboard`, element: <Kanbanboard /> },
    { id: 72, path: `/app/task/listview`, element: <Listview /> },
    { id: 73, path: `/app/task/taskdetails`, element: <Taskdetails /> },

    { id: 74, path: `/app/jobs/jobdetails`, element: <Jobdetails /> },
    { id: 75, path: `/app/jobs/searchcompany`, element: <Searchcompany /> },
    { id: 76, path: `/app/jobs/searchjob`, element: <Searchjob /> },
    { id: 77, path: `/app/jobs/jobpost`, element: <Jobpost /> },
    { id: 78, path: `/app/jobs/joblist`, element: <Joblist /> },
    { id: 79, path: `/app/jobs/searchcandidate`, element: <Searchcandidate /> },
    { id: 80, path: `/app/jobs/candidatedetails`, element: <Candidatedetails /> },

    { id: 81, path: `/app/nft/marketplace`, element: <Marketplace /> },
    { id: 82, path: `/app/nft/nftdetails`, element: <Nftdetails /> },
    { id: 83, path: `/app/nft/createnft`, element: <Createnft /> },
    { id: 84, path: `/app/nft/walletintegration`, element: <Walletintegration /> },
    { id: 85, path: `/app/nft/liveauction`, element: <Liveauction /> },

    { id: 86, path: `/app/crm/crmcontact`, element: <Crmcontact /> },
    { id: 87, path: `/app/crm/companies`, element: <Companies /> },
    { id: 88, path: `/app/crm/deals`, element: <Deals /> },
    { id: 89, path: `/app/crm/leads`, element: <Leads /> },

    { id: 90, path: `/app/crypto/transaction`, element: <Transaction /> },
    { id: 91, path: `/app/crypto/currencyexchange`, element: <Currencyexchange /> },
    { id: 92, path: `/app/crypto/buysell`, element: <Buysell /> },
    { id: 93, path: `/app/crypto/marketcap`, element: <Marketcap /> },
    { id: 94, path: `/app/crypto/wallet`, element: <Wallet /> },

    { id: 95, path: `/uielement/alerts`, element: <Alerts /> },
    { id: 96, path: `/uielement/badges`, element: <Badges /> },
    { id: 97, path: `/uielement/breadcrumb`, element: <Breadcrumbs /> },
    { id: 98, path: `/uielement/buttons`, element: <Buttons /> },
    { id: 99, path: `/uielement/buttongroups`, element: <Buttongroups /> },
    { id: 100, path: `/uielement/cards`, element: <Cards /> },
    { id: 101, path: `/uielement/dropdowns`, element: <Dropdowns /> },
    { id: 102, path: `/uielement/images-figures`, element: <Imagesfigure /> },
    { id: 103, path: `/uielement/listgroup`, element: <Listgroups /> },
    { id: 104, path: `/uielement/navtabs`, element: <Navtabs /> },
    { id: 105, path: `/uielement/objectfit`, element: <Objectfit /> },
    { id: 106, path: `/uielement/paginations`, element: <Paginations /> },
    { id: 107, path: `/uielement/popovers`, element: <Popovers /> },
    { id: 108, path: `/uielement/progressbar`, element: <Progressbar /> },
    { id: 109, path: `/uielement/spinners`, element: <Spinners /> },
    { id: 110, path: `/uielement/toasts`, element: <Toasts /> },
    { id: 111, path: `/uielement/tooltips`, element: <Tooltips /> },
    { id: 112, path: `/uielement/typographys`, element: <Typographys /> },

    { id: 113, path: `/utilities/avatars`, element: <Avatars /> },
    { id: 114, path: `/utilities/borders`, element: <Borders /> },
    { id: 115, path: `/utilities/breakpoints`, element: <Breakpoints /> },
    { id: 116, path: `/utilities/colors`, element: <Colors /> },
    { id: 117, path: `/utilities/columns`, element: <Columns /> },
    { id: 118, path: `/utilities/flex`, element: <Flex /> },
    { id: 119, path: `/utilities/gutters`, element: <Gutters /> },
    { id: 120, path: `/utilities/helpers`, element: <Helpers /> },
    { id: 121, path: `/utilities/position`, element: <Position /> },
    { id: 122, path: `/utilities/additionalcontent`, element: <Additionalcontent /> },

    { id: 123, path: `/forms/formelement/input`, element: <Input /> },
    { id: 124, path: `/forms/formelement/checkradios`, element: <Checkradios /> },
    { id: 125, path: `/forms/formelement/inputgroup`, element: <Inputgroup /> },
    { id: 126, path: `/forms/formelement/formselect`, element: <Formselect /> },
    { id: 127, path: `/forms/formelement/rangeslider`, element: <Rangeslider /> },
    { id: 128, path: `/forms/formelement/inputmasks`, element: <Inputmasks /> },
    { id: 129, path: `/forms/formelement/fileupload`, element: <Fileupload /> },
    { id: 130, path: `/forms/formelement/datetimepicker`, element: <Datetimepicker /> },
    { id: 131, path: `/forms/formelement/colorpicker`, element: <Colorpicker /> },

    { id: 132, path: `/forms/floatinglabels`, element: <Floatinglabels /> },
    { id: 133, path: `/forms/formlayouts`, element: <Formlayouts /> },
    { id: 134, path: `/forms/formeditor/suneditor`, element: <Suneditor /> },
    { id: 135, path: `/forms/validation`, element: <Validation /> },
    { id: 136, path: `/forms/select2`, element: <Select2 /> },

    { id: 137, path: `/advancedui/accordioncollapse`, element: <Accordioncollapse /> },
    { id: 138, path: `/advancedui/carousel`, element: <Carousel /> },
    { id: 139, path: `/advancedui/draggable`, element: <Draggable /> },
    { id: 140, path: `/advancedui/modalcloses`, element: <Modalcloses /> },
    { id: 141, path: `/advancedui/navbar`, element: <Navbar /> },
    { id: 142, path: `/advancedui/offcanvas`, element: <Offcanvas /> },
    { id: 143, path: `/advancedui/placeholder`, element: <Placeholder /> },
    { id: 144, path: `/advancedui/ratings`, element: <Ratings /> },
    { id: 146, path: `/advancedui/swiperjs`, element: <Swiperjs /> },

    { id: 147, path: `/widget`, element: <Widget /> },

    { id: 148, path: `/tables/tables`, element: <Tables /> },
    { id: 149, path: `/tables/gridjstables`, element: <Gridjstables /> },
    { id: 150, path: `/tables/datatables`, element: <Datatables /> },

    { id: 151, path: `/charts/apexchart/Areachart`, element: <Areachart /> },
    { id: 152, path: `/charts/apexchart/Barchart`, element: <Barchart /> },
    { id: 153, path: `/charts/apexchart/Boxplotchart`, element: <Boxplotchart /> },
    { id: 154, path: `/charts/apexchart/Bubblechart`, element: <Bubblechart /> },
    { id: 155, path: `/charts/apexchart/Candlestickchart`, element: <Candlestickchart /> },
    { id: 156, path: `/charts/apexchart/Columnchart`, element: <Columnchart /> },
    { id: 157, path: `/charts/apexchart/FunnelChart`, element: <FunnelChart /> },
    { id: 158, path: `/charts/apexchart/Heatmapchart`, element: <Heatmapchart /> },
    { id: 159, path: `/charts/apexchart/Linechart`, element: <Linechart /> },
    { id: 160, path: `/charts/apexchart/Mixedchart`, element: <Mixedchart /> },
    { id: 161, path: `/charts/apexchart/Piechart`, element: <Piechart /> },
    { id: 162, path: `/charts/apexchart/Polarareachart`, element: <Polarareachart /> },
    { id: 163, path: `/charts/apexchart/Radarchart`, element: <Radarchart /> },
    { id: 164, path: `/charts/apexchart/Radialbarchart`, element: <Radialbarchart /> },
    { id: 165, path: `/charts/apexchart/Rangeareachart`, element: <Rangeareachart /> },
    { id: 166, path: `/charts/apexchart/Scatterchart`, element: <Scatterchart /> },
    { id: 167, path: `/charts/apexchart/Timelinechart`, element: <Timelinechart /> },
    { id: 168, path: `/charts/apexchart/Treemapchart`, element: <Treemapchart /> },
    { id: 169, path: `/charts/chartjs`, element: <Chartjs /> },
    { id: 170, path: `/charts/echart`, element: <Echart /> },

    { id: 171, path: `/maps/leafletmaps`, element: <Leafletmaps /> },
    { id: 172, path: `/maps/pigeonmaps`, element: <Pigeonmaps /> },

    { id: 173, path: `/icons`, element: <Icons /> },
];
